import React from 'react';
import { Switch as SwitchNew } from './Switch';
import { convertOldSwitchProps } from './converter.old';
import type { OldSwitchProps } from './converter.old';

export type SwitchProps = OldSwitchProps;

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>((props, ref) => (
  <SwitchNew {...convertOldSwitchProps(props)} ref={ref} />
));
